export default "__VITE_ASSET__0a4f7710__"